
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics, isSupported } from "firebase/analytics";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBi2DEdwtW5TRRNdbhEdGhxu2q5I5kGlwk",
  authDomain: "titlestorm.firebaseapp.com",
  projectId: "titlestorm",
  storageBucket: "titlestorm.firebasestorage.app",
  messagingSenderId: "223649586516",
  appId: "1:223649586516:web:962b295a2ac04f33ab7cc1",
  measurementId: "G-7YVG9CR33S"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);

// Initialize Analytics conditionally (browser-only)
export const initAnalytics = async () => {
  if (typeof window !== 'undefined') {
    const analyticsSupported = await isSupported();
    if (analyticsSupported) {
      return getAnalytics(app);
    }
  }
  return null;
};

export default app;
